export default {"src":"/_next/static/media/ic-facebook.eb573dc5.svg","height":16,"width":16};